module.exports = __webpack_public_path__ + "img/news.d1c28065.jpg";